var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125.54 168.08",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.17l31.103 54.698 47.905-27.706L47.19.001zm80.08 84.008v56.485l45.224-25.919V84.365zm-51.301-25.91v56.128l45.045 26.276v-56.843z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M78.829 105.998l44.866-25.561-44.688-26.276z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f09990ab.svg";
export { ForwardRef as ReactComponent };